import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import DepositTableHead from '../../components/molecules/DepositTableHead';
import DepositTableBody from '../../components/molecules/DepositTableBody';
import TablePagination from '../../components/molecules/TablePagination';

const styles = {
  scrollTable: {
    maxHeight: 396,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    deposits: state.deposits.deposits,
    depositAmountTotal: state.deposits.depositAmountTotal,
    amountTotal: state.deposits.amountTotal,
    taxAmountTotal: state.deposits.taxAmountTotal,
    feeAmountTotal: state.deposits.feeAmountTotal,
    stripeFeeAmountTotal: state.deposits.stripeFeeAmountTotal,
    secretariatDepositAmountTotal: state.deposits.secretariatDepositAmountTotal
  })),
  setPropTypes(propTypes),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withHandlers({
    handleChangeRowsPerPage: props => event => {
      props.handleChangePage(event, 0);
      props.setRowsPerPage(event.target.value);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    page,
    handleChangePage,
    depositAmountTotal,
    amountTotal,
    taxAmountTotal,
    feeAmountTotal,
    stripeFeeAmountTotal,
    secretariatDepositAmountTotal,
    rowsPerPage,
    deposits,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const totals = {
      depositAmountTotal,
      amountTotal,
      taxAmountTotal,
      feeAmountTotal,
      stripeFeeAmountTotal,
      secretariatDepositAmountTotal
    };

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, deposits.length - page * rowsPerPage);
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <DepositTableHead
              totals={totals}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <DepositTableBody
              deposits={deposits}
              emptyRows={emptyRows}
              page={page}
              order={order}
              orderBy={orderBy}
              rowsPerPage={rowsPerPage}
              roles={roles}
            />
          </Table>
        </div>
        <div>
          <TablePagination
            searchResults={deposits}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
